














































































import Vue from 'vue';
import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import * as api from '@/api';
import DetailHeader from './DetailHeader.vue';
import ProductDes from './ProductDes.vue';
import ToolGroup from './ToolGroup.vue';
import ProductModel from './ProductModel.vue';
import Carousel from './Carousel.vue';
import ProductInfo from './productInfo/index.vue';
import ProductInfoMobile from './productInfo/ProductInfoMobile.vue';
import Attribute from './productInfo/Attribute.vue'; // 属性与规格
import Information from './productInfo/Information.vue'; // 产品描述
import StandardCode from './productInfo/StandardCode.vue'; // 标准编码
import Certification from './productInfo/Certification.vue'; // 认证与评级
import RelatedProduct from './productInfo/RelatedProduct.vue'; // 相关产品
import TechnicalDoc from './productInfo/TechnicalDoc.vue'; // 相关产品
import {
    getProduct, // 属性与规格
    getProductQuality, // 评级
    getProductTechDocs, // 技术文档
    getProductCorrelations, // 相关产品
} from '../../api/ProductDetail';
import { getFileTypes } from '../../api/File';

export default Vue.extend({
    name: 'ProductDetail',
    components: {
        ProductInfoMobile,
        DetailHeader,
        ToolGroup,
        ProductDes,
        ProductModel,
        Carousel,
        ProductInfo,
        Attribute,
        Information,
        Certification,
        RelatedProduct,
        TechnicalDoc,
        StandardCode,
        DownloadDia,
    },
    data() {
        return {
            img_blockchain: false,
            blockchain: {},
            infoMobile: false,
            modelInfo: {},
            fileTypes: [],
            inCollectList: false,
            id: this.$route.params.id,
            carouselVisible: {
                show: false,
            },
            activeId: -1,
            techDocs: [] as { cover: string; name: string; url: string }[],
            information: '',
            attribute: [],
            standardCode: [],
            certification: [],
            relatedProduct: [],
            toolGroupData: [] as {
                id: number;
                zh: string;
                en: string;
                img: string;
                icon: string;
            }[],
            infoTypes: [] as number[],
            toolsData: [
                {
                    id: 1,
                    zh: '查看图片',
                    en: 'INFORMATION',
                    img: 'img_star',
                    icon: 'iconbtn_tupian',
                },
                {
                    id: 2,
                    zh: '产品描述',
                    en: 'INFORMATION',
                    img: 'img_miaoshu',
                    icon: 'iconbtn_guige',
                },
                {
                    id: 3,
                    zh: '属性与规格',
                    en: 'ATTRIBUTE',
                    img: 'img_guige',
                    icon: 'iconbtn_miaoshu',
                },
                {
                    id: 4,
                    zh: '标准编码',
                    en: 'STANDARD CODE',
                    img: 'img_bianma',
                    icon: 'iconbtn_bianma',
                },
                {
                    id: 5,
                    zh: '认证与评级',
                    en: 'CERTIFICATION & RATING',
                    img: 'img_star',
                    icon: 'iconbtn_renzheng',
                },
                {
                    id: 6,
                    zh: '技术文档',
                    en: 'TECHNICAL DOC',
                    img: 'img_jishuwendang',
                    icon: 'iconbtn_wendang',

                },
                {
                    id: 7,
                    zh: '相关产品',
                    en: 'RELATED PRODUCTS',
                    img: 'img_xiangguanchanping',
                    icon: 'iconbtn_xiangguanchanpin',
                },
            ],
            activePreNextIndexs: [] as any, // toolGroup中activeIndex 左右两边的项；
            productDes: {
                name: '',
                brandName: '',
                productSeries: '',
                version: '',
                publishTime: '',
                type: '',
                brandLogo: '',
                fansCount: '',
                group: '',
                productCount: '',
                certLogos: [],
                isConcerned: false,
                brandId: '',
                modelNumber: '',
            },
            carouselData: [] as string[],
            productInfo: {
                mainContent: '',
            } as any,
            dialogVisible: {
                show: false,
            },
        };
    },
    computed: {
        inCompareList(): boolean {
            return !!this.$store.state.compareList.find((p) => p.id.toString() === this.$route.params.id);
        },
        currentProductInfo(): any {
            return this.$store.state.currentProductInfo;
        },
    },
    watch: {
        currentProductInfo: {
            handler(val) {
                document.title = val.name;
            },
            deep: true,
        },
    },
    methods: {
        blockChainToggle(val) {
            this.blockchain = val;
            this.img_blockchain = true;
        },
        async mobileTool(item) {
            await this.selectTool(item);
        },
        closeMobileTool() {
            this.infoMobile = false;
        },
        async openDownloadDia() {
            const isLoginRes = await api.isLogined();
            if (!api.error(isLoginRes)) {
                const fileTypes = await getFileTypes({ id: this.$route.params.id, pvId: this.currentProductInfo.pvId });
                if (!api.error(fileTypes)) {
                    fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
                }
            }
        },
        async collect() {
            let res;
            if (!this.currentProductInfo.isCollected) {
                res = await api.putUserProductCollect([{ pvId: this.currentProductInfo.pvId, productId: this.currentProductInfo.id }]);
            } else {
                res = await api.deleteUserProductCollect([{ productId: this.currentProductInfo.id }]);
            }
            if (!api.error(res)) {
                this.$store.commit('currentProductInfo', { ...this.currentProductInfo, isCollected: !this.currentProductInfo.isCollected });
            }
        },
        async compare() {
            const isLoginRes = await api.isLogined();
            console.log(api.error(isLoginRes));
            if (!api.error(isLoginRes)) {
                if (this.inCompareList) {
                    this.$store.commit('removeCompare', (this as any).currentProductInfo);
                } else if (this.$store.state.compareList.length >= 3) {
                    this.$message({
                        message: '最多可选择三个产品，进行对比',
                        type: 'info',
                    });
                } else {
                    this.$store.commit('addCompare', (this as any).currentProductInfo);
                }
            }
        },
        async getProductInfo() {
            const productInfo: any = await getProduct({ id: this.$route.params.id });
            this.toolGroupData = [];
            if (!api.error(productInfo)) {
                this.$store.commit('currentProductInfo', {
                    id: this.$route.params.id,
                    pvId: productInfo.data.pvId,
                    name: productInfo.data.name,
                    isCollected: productInfo.data.isCollected,
                });
                console.log(productInfo);
                this.infoTypes = productInfo.data.infoTypes.map((id) => id + 1);
                this.toolsData.forEach((item) => {
                    if (this.infoTypes.indexOf(item.id) > -1) {
                        this.toolGroupData = [...this.toolGroupData, item];
                    }
                });
                this.modelInfo = {
                    drawings: productInfo.data.drawings,
                    model: productInfo.data.model,
                    modelGroupId: productInfo.data.modelGroupId,
                };
                this.attribute = productInfo.data.properties;
                if (!productInfo.data.model || !productInfo.data.model.path) {
                    this.activeId = 2;
                    this.getActivePreNextIndexs(2);
                }
                this.productDes = {
                    brandName: productInfo.data.brand ? productInfo.data.brand.name : null,
                    name: productInfo.data.name || '柜式空调',
                    productSeries: productInfo.data.series,
                    version: productInfo.data.version,
                    publishTime: productInfo.data.releasedTime,
                    type: productInfo.data.type,
                    brandLogo: productInfo.data.brand ? productInfo.data.brand.logo : null,
                    isConcerned: productInfo.data.brand ? productInfo.data.brand.isConcerned : null,
                    brandId: productInfo.data.brand ? productInfo.data.brand.brandId : null,
                    fansCount: productInfo.data.brand ? productInfo.data.brand.fansCount.toString() : null,
                    productCount: productInfo.data.brand ? productInfo.data.brand.productCount.toString() : null,
                    certLogos: productInfo.data.certLogos,
                    group: productInfo.data.group,
                    modelNumber: productInfo.data.modelNumber,
                };
                this.carouselData = productInfo.data.images;
                this.information = productInfo.data.description;
                this.standardCode = productInfo.data.standardCodes;
            }
        },
        getActivePreNextIndexs(id) {
            this.activePreNextIndexs = [];
            const index = this.toolGroupData.findIndex((item) => item.id === id);
            const { length } = this.toolGroupData;
            if (index > 0 && index < length - 1) {
                this.activePreNextIndexs = [this.toolGroupData[index - 1], this.toolGroupData[index + 1]];
            } else if (index === 0) {
                this.activePreNextIndexs = [this.toolGroupData[length - 1], this.toolGroupData[1]];
            } else {
                this.activePreNextIndexs = [this.toolGroupData[length - 2], this.toolGroupData[0]];
            }
        },
        async selectTool(item) {
            this.activeId = item.id;
            this.getActivePreNextIndexs(item.id);
            let res;
            switch (item.id) {
                case 1:
                    break;
                case 2:
                    break;
                case 3:
                    break;
                case 4:
                    break;
                case 5:
                    res = await getProductQuality({ id: this.$route.params.id, pvId: this.currentProductInfo.pvId }); // 评级
                    if (res && res.success) {
                        const newData: any = [];
                        const keys = Object.keys(res.data);
                        keys.forEach((i: string) => {
                            newData.push({
                                key: i,
                                value: res.data[i],
                            });
                        });
                        this.certification = newData;
                    }
                    break;
                case 6:
                    res = await getProductTechDocs({ id: this.$route.params.id, pvId: this.currentProductInfo.pvId }); // 技术文档
                    if (res && res.success) {
                        this.techDocs = res.data;
                    }
                    break;
                case 7:
                    res = await getProductCorrelations({ id: this.$route.params.id, pvId: this.currentProductInfo.pvId }); // 相关产品
                    if (res && res.success) {
                        this.relatedProduct = res.data;
                    }
                    break;
                default:
                    break;
            }
            if (item.id === 1) {
                this.carouselVisible.show = true;
            }
        },
        openCarousel() {
            this.carouselVisible.show = true;
        },
    },
    created() {
        document.title = 'iBuilding3D';
        this.getProductInfo();
    },
    beforeDestroy() {
        document.title = 'iBuilding3D';
    },
});
